import { useState } from "react";
import { ctaText } from "@/mocks/cgua";

export default function Subscribe() {
  const [on, setOn] = useState(false);
  return (
    <section id="dingyue" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 pb-12 md:pb-16">
        <div className="rounded-2xl overflow-hidden bg-primary-700 text-background-50 relative">
          {/* deco */}
          <span aria-hidden className="absolute -right-6 -top-6 w-40 h-40 rounded-full bg-primary-500/50 blur-2xl" />
          <span aria-hidden className="absolute -left-8 bottom-0 w-32 h-32 rounded-full bg-accent-500/30 blur-2xl" />
          <div className="relative px-5 py-8 md:px-10 md:py-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div className="max-w-xl">
              <h2 className="flex items-center gap-2 text-lg md:text-2xl font-bold font-heading">
                <i className="ri-notification-3-fill text-accent-300" />
                追更，别让瓜溜走
              </h2>
              <p className="mt-2 text-sm md:text-base leading-relaxed text-background-50/90">
                {ctaText}
              </p>
            </div>
            <button
              type="button"
              onClick={() => setOn((v) => !v)}
              className={
                "inline-flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-3 text-sm font-bold transition-colors cursor-pointer " +
                (on
                  ? "bg-background-50 text-primary-700"
                  : "bg-accent-500 text-foreground-950 hover:bg-accent-400")
              }
            >
              <i className={on ? "ri-check-line text-[16px]" : "ri-add-circle-line text-[16px]"} />
              {on ? "已在追更名单里" : "开启订阅追更"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}